// src/app/pages/jornalmove/watch/watch.service.ts
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FeatureComparison } from '../../../models/feature-comparison.model';
import { ViewScopeService } from '../../../services/view-scope.service';
import { AjaxService } from '../../../services/ajax.service';
import { ExportMovinService } from '../../../services/export-movin.service';
import { AuthStateService } from '../../../services/auth-state.service';

import { GET_IND_JOR_BY_FILE, GET_ALL_JOR_BY_CUST, UPD_EXP_TAB, INS_EXP_TAB, UPD_FF_TAB} from '../../../services/account-api.constants';

@Injectable({
	providedIn: 'root'
})

export class WatchService {
	public dialogChangesMade = false;   // For tracing if eye-dialog made any changes.


	constructor(private ajaxService: AjaxService, private viewScopeService: ViewScopeService, private exportMovinService: ExportMovinService, private authStateService: AuthStateService) { }

	getInvoices(customerRecID: string, userRecID: string, fileRecId : number = -1): Observable<any[]> {
		return fileRecId == -1 ?
			   this.ajaxService.getData(this.ajaxService.getBaseOfApi() + GET_ALL_JOR_BY_CUST + customerRecID + '/' + userRecID) as Observable<any[]>:
			   this.ajaxService.getData(this.ajaxService.getBaseOfApi() + GET_IND_JOR_BY_FILE + fileRecId + '/' + userRecID) as Observable<any[]>;
	}


	public exportMovein(listOfJournals: number[], isAttempt: 0 | 1 = 0): Observable<any> 
	{
		return this.exportMovinService.exportMovein(listOfJournals, isAttempt);
	}

	// operation: True for insert, False for update
	public buildExpenseTabData(operation: boolean, leadingId: string, itemId: string, expCode: string) {
		const userRecId = this.viewScopeService.getCurrentOpertaingUserId().toString() || '';
		const payload: any = {
			"Confidence": "1.0",
			"item": itemId,
			"ExpenseCode": expCode,
			"CustomerRecID": this.viewScopeService.getCurrentCustomer(),
			"Descr": "inserted by: " + this.authStateService.getFirstName() + ' ' + this.authStateService.getLastName(),
			"UserRecID": userRecId
		};
		if (operation) {
			payload["FileRecID"] = leadingId;
		}
		else {
			payload["RecID"] = leadingId;
		}
		return payload;
	}

	public updateExpenseTab(obj: any) {
		console.log('updateExpenseTab obj:', obj);
		return this.ajaxService.updateObjectData(this.ajaxService.getBaseOfApi() + UPD_EXP_TAB, obj);
	}

	public insertExpenseTab(obj: any) {
		console.log('insertExpenseTab obj:', obj);
		return this.ajaxService.addObjectData(this.ajaxService.getBaseOfApi() + INS_EXP_TAB, obj);
	}

	public updateFeaturesTab(features: FeatureComparison[], fileRecID: number) {
		const payloadObj = this.createSaveFFPayload(features, fileRecID);
		return this.ajaxService.updateObjectData(this.ajaxService.getBaseOfApi() + UPD_FF_TAB, payloadObj);
	}

	public createSaveFFPayload(features: FeatureComparison[], fileRecID: number) {
		const userRecID = this.viewScopeService.getCurrentOpertaingUserId();

		const FF = features.map(f => {
			const file_feature_id = f.ID ?? null;
			const feature_id = f.RecID ?? null;
			return {
				"file_feature_id": file_feature_id,
				"file_feature_value": f.FeatureValueStd ?? '',
				"feature_id": file_feature_id ? null : feature_id
			};
		});

		const result = {
			"FileRecID": fileRecID,
			"UserRecID": userRecID,
			"FF": FF
		};
		console.log('createSaveFFPayload result (raw):', JSON.stringify(result));
		return JSON.stringify(result);
	}

}